import React, { Component } from 'react';
import { store } from "Store/store.index";
import { Modal,} from 'antd';
import  "./Preferences.scss";
import intl from 'react-intl-universal';
import { Button } from 'antd'
// import { fileController } from "../../viewer/Controllers/index";

 class EntryList extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
        formPreference:store.docStore.formPreference,
        disabledColor:"#4f4b4b",
        layoutPreference:store.docStore.layoutPreference,
        removeItemKey:'',
        removeItemText:''
       
    }
    this.handleClose = this.handleClose.bind(this);
    this.handleRemoveAll = this.handleRemoveAll.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.changeKey = this.changeKey.bind(this);

  }

   componentDidMount(){
   
  }
 
  handleClose(){
    this.props.close()
  }
  handleRemoveAll(){
    this.props.handleRemoveAll()  
  }
  handleRemove(){
  }
  changeKey(key,text){
    this.setState({
        removeItemKey:key,
        removeItemText:text
    })
  }
  render() {
    const { visible,AutoCompleteEntries } = this.props;
    const { removeItemKey } = this.state;
  
    return (
        <Modal
          className='entry-list-dialog'
          maskClosable={false}
          title={intl.formatMessage({ id: 'Preferences.Content.AutoComplete.EntryList.title' })}
          visible={visible}
        //   cancelText={intl.formatMessage({ id: 'Preferences.Modal.Cancel' })}
          onCancel={this.handleClose}
          centered={true}
          footer={(
            <div className='wrapButton'>
                <Button onClick={this.handleClose}>{intl.formatMessage({ id: 'Preferences.Content.AutoComplete.EntryList.close' })}</Button>

                <Button className='RemoveAll' onClick={this.handleRemoveAll}>{intl.formatMessage({ id: 'Preferences.Content.AutoComplete.EntryList.RemoveAll' })}</Button>
                {/* SDK 接口未支持  暂时屏蔽此按钮 */}
                {/* <Button onClick={this.handleClose}>{intl.formatMessage({ id: 'Preferences.Content.AutoComplete.EntryList.Remove' })}</Button> */}
            </div>
            )}
        >
           <p>{intl.formatMessage({ id: 'Preferences.Content.AutoComplete.EntryList.tips' })}</p>
           <div className="content">
               <ul>
               {AutoCompleteEntries.map((item,itemIndex)=>{
                    return <li className={itemIndex == removeItemKey?'active':''} key={itemIndex} onClick={()=>{this.changeKey(itemIndex,item.text)}}>{item.text}</li>
                })}
               </ul>
           </div>
        </Modal>
    );
  }
}
export default  EntryList;